import { apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

export const learningPathsApi = {
  list: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/learning-paths?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ data: Record<string, unknown> }>(`/learning-paths/${id}`),

  getBySlug: (slug: string) => apiGet<{ data: Record<string, unknown> }>(`/learning-paths/${slug}/by-slug`),

  create: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>("/learning-paths", body),

  update: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`/learning-paths/${id}`, body),

  delete: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`/learning-paths/${id}`),

  addCourse: (id: string, body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`/learning-paths/${id}/courses`, body),

  removeCourse: (id: string, courseId: string) => apiDelete<{ data: Record<string, unknown> }>(`/learning-paths/${id}/courses/${courseId}`),

  updateCourse: (id: string, courseId: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`/learning-paths/${id}/courses/${courseId}`, body),

  bulkDelete: (pathIds: string[]) => apiDelete<{ data: number }>("/learning-paths/bulk-delete", { data: { pathIds } }),

  getStats: () => apiGet<{ data: Record<string, unknown> }>("/learning-paths/stats"),

  export: (format = "CSV") => apiGet<{ data: unknown }>(`/learning-paths/export?format=${format}`),
};
